import InteriorDoorInstallationInformation from './InteriorDoorInstallationInformation';

export default InteriorDoorInstallationInformation;